<template>
  <spring-spinner :style="styleSpiner" :color="$themes.primary" v-if="isLoading" />
  <div v-else>
    <div class="row">
      <div class="flex xs12 xl6">
        <va-card>
          <ul>
            <li class="cover_photos">
              <span>{{  $t('bls.single.cover_photos')  }}:</span>
              <a v-for="photo in report.bls_report_photos" :key="photo.id" :href="photo.file">
                <img :src="photo.file" />
              </a>
            </li>
            <li>
              <span>{{  $t('bls.single.description')  }}:</span>
              {{  report.description  }}
            </li>
            <li>
              <span>{{  $t('bls.single.bls_percent')  }}:</span>
              {{  report.bls_percent  }}
            </li>
            <li>
              <span>BLS charge:</span>
              {{  report.bls_charged  }}
            </li>

            <li>
              <span>{{  $t('bls.single.bls')  }}:</span>
              {{  report.bls  }}$
            </li>
            <li>
              <span>Created at:</span>
              {{  moment(report.created_at).format('l')  }}
            </li>
            <li>
              <span>{{  $t('bls.single.viewed')  }}:</span>
              {{  report.viewed ? "✔️" : "❌"  }}
            </li>
            <li>
              <span>{{  $t('bls.single.lender')  }}:</span>

              <router-link :to="{ name: 'user-single', params: { id: lender.id } }">
                {{  lender.get_full_name  }}
              </router-link>
            </li>
            <li>
              <span>{{  $t('bls.single.borrower')  }}:</span>

              <router-link :to="{ name: 'user-single', params: { id: borrower.id } }">
                {{  borrower.get_full_name  }}
              </router-link>
            </li>
            <li class="d-flex alin-items-center">
              <span>{{  $t('bls.single.status')  }}:</span>
              <span :style="{ width: '150px' }">
                <va-select :loading="isStatusLoading" v-model="status" :options="statuses"
                  :disabled="statuses.includes(status)" noClear />
              </span>
            </li>
            <li class="d-flex alin-items-center">
              <span>{{  $t('bls.single.publication')  }}:</span>
              <spring-spinner :color="$themes.primary" :size="10" class="ml-3 mt-3" v-if="!publication.title" />
              <router-link class="ml-1" :to="{ name: 'publications-single', params: { id: publication.id } }">
                {{  publication.title  }}
              </router-link>
            </li>
          </ul>
        </va-card>
      </div>
      <div class="flex xs12 xl6">
        <va-card>
          <spring-spinner :color="$themes.primary" :size="50" :style="styleSpiner" v-if="isLoadingMessages" />
          <chat-bls v-else-if="messages.length" :messages="messages" @send-message="preSendMessage" />
        </va-card>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import { SpringSpinner } from 'epic-spinners'
import ChatBls from './components/ChatBls.vue'
import moment from 'moment'

export default {
  data() {
    return {
      report: {},
      isStatusLoading: false,
      publication: {},
      messages: [],
      isLoadingMessages: true,
      isLoading: true,
      statuses: ['CONFIRMED', 'REJECTED'],
    }
  },
  components: { SpringSpinner, ChatBls },
  computed: {
    lender() {
      return this.report.lender ?? {}
    },
    status: {
      get() {
        console.log(this.report.status)
        return this.statuses[this.report.status - 2]
      },
      async set(val) {
        this.isStatusLoading = true
        const status = this.statuses.indexOf(val) + 2

        const response = await this.changeStatus({ status, blsID: this.blsReportId })

        if (response.status >= 200 && response.status < 300) {
          this.report.status = status
          this.showToast(
            'Ok',
            {
              icon: 'fa-check',
              position: 'bottom-right',
              duration: 2500,
              fullWidth: false,
            },
          )
        } else {
          this.showToast(
            response.data?.detail,
            {
              icon: 'fa-close',
              position: 'bottom-right',
              duration: 2500,
              fullWidth: false,
              type: 'error',
            },
          )
        }
        this.isStatusLoading = false
      },
    },
    borrower() {
      return this.report.borrower ?? {}
    },
    blsReportId() {
      return this.$route.params.id
    },
    styleSpiner() {
      return {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
      }
    },
  },
  methods: {
    moment,
    ...mapActions('Bls', ['fetchReportItem', 'getMessagesByReport', 'sendMessage', 'changeStatus']),
    ...mapActions('Publications', ['getSingle']),
    async preSendMessage(value) {
      value.report = this.blsReportId
      const response = await this.sendMessage(value)

      if (response.status === 200) {
        this.messages.push(response.data)
      }
    },
    async getPublication() {
      const res = await this.getSingle(this.report.publication)
      this.publication = res.data ?? { title: this.report.title }
    },
    async getReport(loading = true) {
      this.isLoading = loading
      const response = await this.fetchReportItem(this.blsReportId)
      this.report = response.data
      this.isLoading = false
      if (response.status !== 200) {
        this.$router.push({ name: 'bls' })
      }
    },
    async getReportMessages(loading = true) {
      this.isLoadingMessages = loading
      const response = await this.getMessagesByReport(this.blsReportId)
      this.messages = response.data?.results?.reverse() ?? []
      this.isLoadingMessages = false
    },
  },
  async created() {
    await this.getReport()
    await this.getReportMessages()
    await this.getPublication()
  },
}
</script>
<style lang="scss" scoped>
ul {
  li {
    font-size: 20px;

    span {
      font-weight: 600;
    }
  }

  .ban {
    padding: 15px;
    border: 1px solid var(--va-textColor);

    &:not(:last-child) {
      border-bottom: none;
    }
  }
}

.cover_photos {
  display: flex;
  flex-wrap: wrap;

  img {
    width: 100px;
    height: 100px;
    object-fit: cover;
    object-position: center;
    margin-left: 10px;
  }
}
</style>
